import { Container, Row, Col, Card, Button } from "react-bootstrap";
import {
  FaCheckCircle,
  FaUsers,
  FaCalendarAlt,
  FaAward,
  FaChartLine,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import about from "../assets/images/aboutpage2.jpg";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function About() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  return (
    <>
      <Helmet>
        <title>{t("seo.about.title")}</title>
        <meta name="description" content={t("seo.about.description")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${window.location.origin}/${currentLang}/about`} />

        <meta property="og:title" content={t("seo.about.title")} />
        <meta property="og:description" content={t("seo.about.description")} />
        <meta property="og:url" content={`${window.location.origin}/${currentLang}/about`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("seo.about.title")} />
        <meta
          name="twitter:description"
          content={t("seo.about.description")}
        />
        <meta name="twitter:image" content="path/to/your/image.jpg" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white page-header">
        <Container>
          <div style={{ maxWidth: "800px" }}>
            <h1 className="display-4 fw-bold mb-4">{t("about.hero.title")} </h1>
            <p className="fs-4 text-white-80">{t("about.hero.description")} </p>
          </div>
        </Container>
      </section>

      {/* Company Story */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 className="mb-4">{t("about.hero.title")} </h2>
              <p className="text-secondary mb-4">
                {t("about.story.paragraph1")}{" "}
              </p>
              <p className="text-secondary mb-4">
                {t("about.story.paragraph2")}{" "}
              </p>
              <p className="text-secondary">{t("about.story.paragraph3")} </p>
            </Col>

            <Col lg={6}>
              <div
                className="about-story-image"
                style={{ height: "500px", position: "relative" }}
              >
                <img
                  src={about || "/placeholder.svg"}
                  alt="Betonbum History"
                  className="img-cover"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  loading="lazy"

                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission & Values */}
      <section className="section-padding bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="mb-3">{t("about.mission.title")} </h2>
            <p className="text-secondary mx-auto" style={{ maxWidth: "700px" }}>
              {t("about.mission.description")}{" "}
            </p>
          </div>

          <Row className="g-4">
            <Col lg={6}>
              <Card className="mission-card">
                <Card.Body className="p-4">
                  <h3 className="mb-3">{t("about.mission.missionTitle")} </h3>
                  <p className="text-secondary">
                    {t("about.mission.missionText")}{" "}
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card className="values-card">
                <Card.Body className="p-4">
                  <h3 className="mb-3">{t("about.mission.valuesTitle")} </h3>
                  <ul className="list-unstyled values-list">
                    {[
                      {
                        icon: <FaCheckCircle className="value-icon" />,
                        title: t("about.mission.quality.title"),
                        description: t("about.mission.quality.description"),
                      },
                      {
                        icon: <FaUsers className="value-icon" />,
                        title: t("about.mission.teamwork.title"),
                        description: t("about.mission.teamwork.description"),
                      },
                      {
                        icon: <FaCalendarAlt className="value-icon" />,
                        title: t("about.mission.timelesness.title"),
                        description: t("about.mission.timelesness.description"),
                      },
                      {
                        icon: <FaAward className="value-icon" />,
                        title: t("about.mission.integrity.title"),
                        description: t("about.mission.integrity.description"),
                      },
                      {
                        icon: <FaChartLine className="value-icon" />,
                        title: t("about.mission.innovation.title"),
                        description: t("about.mission.innovation.description"),
                      },
                    ].map((value, index) => (
                      <li key={index} className="d-flex mb-3">
                        <div className="me-3 mt-1">{value.icon}</div>
                        <div>
                          <h4 className="fw-bold mb-1">{value.title}</h4>
                          <p className="text-secondary mb-0">
                            {value.description}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section className="section-padding">
        {/* <Container>
            <div className="text-center mb-5">
              <h2 className="mb-3">{t("about.team.title")}{" "}</h2>
              <p className="text-secondary mx-auto" style={{ maxWidth: "700px" }}>
              {t("about.team.description")}{" "}
              </p>
            </div>

            <Row className="g-4">
              {[
                {
                  image: "/placeholder.svg",
                  name: t("about.team.ceo.name"),
                  position: t("about.team.ceo.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.coo.name"),
                  position: t("about.team.coo.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.la.name"),
                  position: t("about.team.la.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.pm.name"),
                  position: t("about.team.pm.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.cm.name"),
                  position: t("about.team.cm.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.fd.name"),
                  position: t("about.team.fd.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.so.name"),
                  position: t("about.team.so.position"),
                },
                {
                  image: "/placeholder.svg",
                  name: t("about.team.cr.name"),
                  position: t("about.team.cr.position"),
                },
              ].map((member, index) => (
                <Col key={index} md={6} lg={3}>
                  <Card className="team-card">
                    <div style={{ height: "250px", overflow: "hidden" }}>
                      <Card.Img
                        variant="top"
                        src={member.image}
                        alt={member.name}
                        className="img-cover"
                        style={{ height: "100%" }}
                      />
                    </div>
                    <Card.Body className="text-center">
                      <Card.Title className="fw-bold mb-1">{member.name}</Card.Title>
                      <Card.Text className="text-secondary">{member.position}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container> */}
      </section>
      <section className="cta-section section-padding">
        <Container>
          <div className="cta-content">
            <h2>{t("home.cta.title")} </h2>
            <p>{t("home.cta.description")} </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Button
                variant="tertiary"
                size="lg"
                as={Link}
                to={`/${currentLang}/contact`}
              >
                {t("home.cta.buttonQuote")}{" "}
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default About;
